// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lx-0";
export var buttonContainer = "_lx-3";
export var cancelButton = "_lx-4";
export var headerSection = "_lx-6";
export var headerTitle = "_lx-9";
export var messageSideLeft = "_lx-1";
export var messageSideRight = "_lx-2";
export var orderNumberContainer = "_lx-7";
export var orderNumberLabel = "_lx-8";
export var submitButton = "_lx-5";